import { NgIf } from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { RippleDirective } from '../../ripple.directive';

export interface IDialogData {
  titleIcon: string;
  title: string;
  messageIcon: string;
  message: string;
  hideCancelButton?: boolean;
  confirmButtonText?: string;
  outlinedIcons?: boolean;
  confirmButtonIcon?: string;
  alternativeButtonText?: string;
  alternativeButtonIcon?: string;
}

@Component({
  selector: 'app-data-rules-confirm-dialog',
  templateUrl: './data-rules-confirm-dialog.component.html',
  imports: [
    MatDialogTitle,
    NgIf,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    RippleDirective
  ],
  styleUrls: ['./data-rules-confirm-dialog.component.scss']
})
export class DataRulesConfirmDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DataRulesConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onAlternativeClick(): void {
    this.dialogRef.close('alternative');
  }

  ngOnInit(): void {
    this.data.confirmButtonText = this.data.confirmButtonText ? this.data.confirmButtonText : 'Yes';
  }
}
